import { Grid, useStyles, Flex } from '@archipro-design/aria';
import HeroTitle from './HeroTitle';

import HeroContent from './HeroContent';

import CategoryNavigation from '../category-navigation/CategoryNavigation';
import SubscriptionForm from '../subscription-form/SubscriptionForm';
import { useMatches } from 'react-router';
import { BASE_URL, DEFAULT_TITLE } from '@modules/articles/config/constants';
import type { DirectoryHeaderProps } from './DirectoryHeader';

import * as S from './DirectoryHeader.style';

export const DirectoryHeaderMobile: React.FC<DirectoryHeaderProps> = ({
    navItems,
    content,
}) => {
    const { css } = useStyles();
    const matchingRoutes = useMatches();
    const activeRoute = matchingRoutes[
        matchingRoutes.length - 1
    ]!.pathname.replace(/\/$/, '');

    const activeMenuItem = navItems.find((nav) => nav.link === activeRoute);
    const isRoot = activeMenuItem?.link === BASE_URL;
    const title =
        !isRoot && activeMenuItem?.title ? activeMenuItem.title : DEFAULT_TITLE;

    return (
        <Grid columns={`100%`} className={css(S.Container)}>
            <Flex hAlign="center" column={true}>
                <HeroTitle title={title} />
                <HeroContent content={content} />
                <SubscriptionForm />
            </Flex>
            <CategoryNavigation navItems={navItems} />
        </Grid>
    );
};
